import React from "react";
import { TgRequirementsSearch } from "./tg-requirements-search";

export function TgRequirementsSearchPage() {
  return <TgRequirementsSearch />;
}
